import type { FC } from "react";

type HeroSwirlProps = {
  className?: string;
};

export const HeroSwirl: FC<HeroSwirlProps> = ({ className }) => (
  <svg
    aria-hidden
    viewBox="0 0 1726.85 602"
    fill="none"
    preserveAspectRatio="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      opacity="0.22"
      d="M-510.262 487.333C-223.452 114.667 92.0381 172 407.528 344C723.019 516 981.147 544.667 1354 172C1726.85 -200.667 1812.89 114.667 1898.94 315.333"
      stroke="#8EDBEA"
      strokeWidth="107.928"
      strokeLinecap="round"
    />
    <path
      opacity="0.55"
      d="M1067.19 -114.667C1267.96 28.6665 1411.36 172 1397.02 344C1382.68 458.667 1296.64 516 1167.57 487.333"
      stroke="#BFEFF8"
      strokeWidth="83.9442"
      strokeLinecap="round"
    />
    <path
      opacity="0.35"
      d="M-338.176 501.667C34.6765 430.001 378.848 602.001 751.7 516.001C1067.19 444.334 1354 358.334 1726.85 473.001V602.001H-338.176V501.667Z"
      fill="white"
    />
  </svg>
);
